import { SelectionState } from "@alfresco/adf-extensions";
import { MinimalNodeEntity } from "@alfresco/js-api";
import { Action } from "@ngrx/store";

export enum TransferActionTypes {
    CreateCalendarTransfer = 'CREATE_CALENDAR_TRANSFER',
    ViewCalendarTransfer = "VIEW_CALENDAR_TRANSFER",
    EditCalendarTransfer = "EDIT_CALENDAR_TRANSFER",
    DeleteCalendarTransfer = 'DELETE_CALENDAR_TRANSFER',
    CreateTransfer = 'CREATE_TRANSFER',
    EditTransfer = "EDIT_TRANSFER",
    ValidateTransfer = "VALIDATE_TRANSFER",
    CatalogTransfer = "CATALOG_TRANSFER",
    ViewTransfer = "VIEW_TRANSFER",
    UnlockEditTransfer = "UNLOCK_EDIT_TRANSFER",
    DeleteTransfer = 'DELETE_TRANSFER',
}

export class CreateCalendarTransferAction implements Action {
  readonly type = TransferActionTypes.CreateCalendarTransfer;

  constructor(public payload?: SelectionState) {}
}

export class ViewCalendarTransferAction implements Action {
  readonly type = TransferActionTypes.ViewCalendarTransfer;

  constructor(public payload?: SelectionState) {}
}

export class EditCalendarTransferAction implements Action {
  readonly type = TransferActionTypes.EditCalendarTransfer;

  constructor(public payload?: SelectionState) {}
}

export class DeleteCalendarTransferAction implements Action {
  readonly type = TransferActionTypes.DeleteCalendarTransfer;

  constructor(public payload: MinimalNodeEntity[] = []) {}
}

export class CreateTransferAction implements Action {
  readonly type = TransferActionTypes.CreateTransfer;

  constructor(public payload?: SelectionState) {}
}

export class EditTransferAction implements Action {
  readonly type = TransferActionTypes.EditTransfer;

  constructor(public payload?: SelectionState) {}
}

export class ValidateTransferAction implements Action {
  readonly type = TransferActionTypes.ValidateTransfer;

  constructor(public payload?: SelectionState) {}
}

export class CatalogTransferAction implements Action {
  readonly type = TransferActionTypes.CatalogTransfer;

  constructor(public payload?: SelectionState) {}
}

export class ViewTransferAction implements Action {
  readonly type = TransferActionTypes.ViewTransfer;

  constructor(public payload?: SelectionState) {}
}

export class UnlockEditTransferAction implements Action {
  readonly type = TransferActionTypes.UnlockEditTransfer;

  constructor(public payload?: SelectionState) {}
}

export class DeleteTransferAction implements Action {
  readonly type = TransferActionTypes.DeleteTransfer;

  constructor(public payload: MinimalNodeEntity[] = []) {}
}